import React from "react";
import Styles from "../../assets/css/Loadings/Loading.module.css";

const Loading = () => {
  return (
    <>
      <div className={Styles.LoadingContainer}>
        <span></span>
      </div>
    </>
  );
};

export default Loading;
